export default __webpack_public_path__ + "static/media/main-characters-padded.7ac8c3a8.webp";